module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage2.jpg?v=695508ed";